import React from "react";
import okLogo from "../../assets/images/ok-logo.png";
import Nathicharami from "../../assets/images/Nathicharami.png";
import "./Header.css";
import zoomImg from "../../assets/images/pngwing.com 1.png";
import okImg from "../../assets/images/okImg.png";
import whiteImg from "../../assets/images/White 1.png";
import whiteBG from "../../assets/images/White BG.png";
import colorImg from "../../assets/images/colour.png";
import colorBG from "../../assets/images/colour BG.png";

export const Header = () => {
  return (
    // <div className="main-header container">
    //   <div className="header-left-part">
    //     <img src={okLogo} alt="logo" />
    //     <div className="header-left-text">
    //       <p>Arihant Raaj</p>
    //       <p>Vastu Astro Numero Expert</p>
    //     </div>
    //   </div>
    //   <div className="header-right-part">
    //     <img src={Nathicharami} alt="Nathicharami" />
    //   </div>
    // </div>
    <div className="headerContainer container">
      <div className="headerImg"><img src={zoomImg}/></div>
      <div className="headersubContainer">
      <div className="headerOkImg"><img src={colorImg}/></div>
        {/* <div className="headerContent">
          <div>Arihant Raaj</div>
          <div>Vastu Astro Numero Expert</div>

        </div> */}
      </div>
    </div>
  );
};
